import {
  CUSTOM_FIELDS_REQUIRED_ERROR,
  CUSTOM_FIELDS_VALIDATION_ERROR,
} from '../../CustomFieldsSection.constants';

const ERROR_KEY_TO_MESSAGE = {
  required: CUSTOM_FIELDS_REQUIRED_ERROR,
  [CUSTOM_FIELDS_VALIDATION_ERROR.EMAIL]: CUSTOM_FIELDS_VALIDATION_ERROR.EMAIL,
  [CUSTOM_FIELDS_VALIDATION_ERROR.PHONE]: CUSTOM_FIELDS_VALIDATION_ERROR.PHONE,
  [CUSTOM_FIELDS_VALIDATION_ERROR.URL]: CUSTOM_FIELDS_VALIDATION_ERROR.URL,
};

export const resolveErrorMessage = errorKey => ERROR_KEY_TO_MESSAGE[errorKey] ?? '';
